var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGainersLosers = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 0h-5v1h3.293l-3.111 3.11a1.5 1.5 0 0 1-2.121 0l-.707-.706a2.5 2.5 0 0 0-3.536 0L1 7.222V4H0v5h5V8H1.636l3.89-3.89a1.5 1.5 0 0 1 2.12 0l.708.708a2.5 2.5 0 0 0 3.535 0L15 1.708V5h1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 9v6h-2v-4a2 2 0 1 0-4 0v4H4v-1a2 2 0 1 0-4 0v2h16V9a2 2 0 1 0-4 0m3 0a1 1 0 1 0-2 0v6h2zM1 14v1h2v-1a1 1 0 1 0-2 0m8 1v-4a1 1 0 1 0-2 0v4z",
  clipRule: "evenodd"
})));
export default SvgGainersLosers;